import BackDropComponent from "@/components/BackDrop";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import { addTagsRequest } from "@/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { enqueueSnackbar } from "notistack";
const BulkActivity = () => {
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const fileInputRef = useRef(null);
    const [fileName, setFileName] = useState("");
    const dispatch = useDispatch();
    const [formattedData, setFormattedData] = useState([]);
    const addTagsState = useSelector((state) => state.addTagsReducer);
    const handleFileUpload = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const handleFileChange = (event) => {
        var _a;
        const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file)
            return;
        setFileName(file.name);
        if (file) {
            enqueueSnackbar("File uploaded succesfully", {
                variant: "success",
            });
        }
        const reader = new FileReader();
        reader.onload = (e) => {
            var _a;
            const arrayBuffer = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
            const data = new Uint8Array(arrayBuffer); // Rename this variable if necessary
            const workbook = XLSX.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
            // Extract headers and data
            const [headers, ...rows] = jsonData;
            if (headers.length < 3) {
                console.error("Invalid file format");
                return;
            }
            const newFormattedData = rows.map((row) => ({
                orderId: row[0],
                tags: row[1],
                action: "Add",
            }));
            // Set the formatted data to state
            setFormattedData(newFormattedData);
        };
        reader.readAsArrayBuffer(file);
    };
    const handleSave = (formattedData) => {
        const tenantId = localStorage.getItem("tenantId"); // Get tenantId from localStorage
        if (!tenantId) {
            enqueueSnackbar("Tenant ID is missing", { variant: "error" });
            return;
        }
        setIsBackOpenOpen(true);
        dispatch(addTagsRequest({ tenantId, data: formattedData })); // Send tenantId in payload
    };
    React.useEffect(() => {
        if (addTagsState.data !== null) {
            enqueueSnackbar("Tags updated succesfully", {
                variant: "success",
            });
            setIsBackOpenOpen(false);
        }
        else if (addTagsState === null || addTagsState === void 0 ? void 0 : addTagsState.error) {
            enqueueSnackbar("Unable to update tags.", {
                variant: "ErrorMessage",
            });
            setIsBackOpenOpen(false);
        }
    }, [addTagsState]);
    return (React.createElement(Grid, { container: true, direction: "column", sx: { p: 4, minHeight: "calc(100vh - 66px)" }, className: "m_background_color" },
        React.createElement(Grid, { mb: 2, pl: 1 },
            React.createElement(Typography, { sx: {
                    fontFamily: "Poppins",
                    fontSize: "20px",
                    fontWeight: 600,
                    lineHeight: "30px",
                    textAlign: "left",
                    color: "#121114",
                } }, "Bulk activity")),
        React.createElement(Paper, { sx: { p: 3, borderRadius: 2, boxShadow: "none", overflow: "visible", border: "1px solid #D2D1D6" } },
            React.createElement(Typography, { variant: "subtitle1", fontWeight: 600, mb: 2 }, "Update order tags"),
            React.createElement(Grid, { item: true, xs: 12, container: true, spacing: 2, direction: "row" },
                React.createElement(Grid, { item: true, xs: 9, marginTop: 1.2 },
                    React.createElement(Typography, { sx: { fontFamily: "Poppins", fontWeight: 500, fontSize: "16px", color: "#121114" } }, "Download Sample file")),
                React.createElement(Grid, { item: true, xs: 3 },
                    React.createElement(Box, { sx: {
                            border: "1px dashed #ccc",
                            p: 1.5,
                            borderRadius: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        } },
                        React.createElement(Box, { display: "flex", alignItems: "center", gap: 1 },
                            React.createElement(CloudUploadIcon, { fontSize: "small" }),
                            React.createElement(Typography, { variant: "body2" }, "Sample file")),
                        React.createElement(Typography, { variant: "caption" }, "10 KB")))),
            React.createElement(Grid, { item: true, xs: 12, container: true, spacing: 2, direction: "row", marginTop: "2px" },
                React.createElement(Grid, { item: true, xs: 9 },
                    React.createElement(Typography, { sx: { fontFamily: "Poppins", fontWeight: 500, fontSize: "16px", color: "#121114" } }, "Upload final file")),
                React.createElement(Grid, { item: true, xs: 3 },
                    React.createElement(Button, { fullWidth: true, variant: "outlined", startIcon: React.createElement(CloudUploadIcon, null), onClick: handleFileUpload }, "Upload File"),
                    React.createElement("input", { type: "file", ref: fileInputRef, style: { display: "none" }, accept: ".xlsx", onChange: handleFileChange })),
                fileName && (React.createElement(Grid, { item: true, xs: 12, container: true, justifyContent: "flex-end" },
                    React.createElement(Grid, { item: true, xs: 2.9 },
                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontWeight: 500, fontSize: "14px", color: "#121114" } }, fileName)))),
                React.createElement(Grid, { item: true, xs: 12, container: true, justifyContent: "flex-end" },
                    React.createElement(Grid, { item: true, xs: 2.9 },
                        React.createElement(Button, { fullWidth: true, variant: "contained", color: "error", onClick: () => handleSave(formattedData) }, "Save"))))),
        React.createElement(BackDropComponent, { open: isBackOpenOpen })));
};
export default BulkActivity;
